import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import Vue from 'vue'

// create an axios instance
const service = axios.create({
  baseURL: '/api', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 500000 // request timeout
})
const CancelToken = axios.CancelToken

// request interceptor
service.interceptors.request.use(
  config => {
    config['cancelToken'] = new CancelToken(function executor(cancel) {
      Vue.prototype.$httpRequestList.push(cancel) //存储cancle
    })
    // do something before request is sent
    let token = localStorage.getItem('token')
    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['token'] = token
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      Message({
        message: res.desc || '出错',
        type: 'error',
        duration: 3 * 1000
      })


      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('你的登录状态已过期，请重新登录', 'Confirm logout', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            localStorage.clear()
            location.reload()
        })
      }
      return Promise.reject(new Error(res.desc || '出错'))
    } else {
      return res
    }
  },
  error => {
    if(error.message === 'interrupt') {
      console.log('请求中断');
      return new Promise(() => {});
    }
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
